import { app } from '../../../../../app';
import { Controller } from './directory-manage-connection.controller';

app.component('companyDirectoryIntegrationManageConnection', {
    bindings: {
        connectionDetails: '<',
        companyId: '<',
        directory: '<',
        optionalOnPrem: '<',
    },
    controller: Controller,
    templateUrl: require('./directory-manage-connection.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/connection/directory-manage-connection.component.js